import { createAction, ActionFunctionAny, Action } from "redux-actions";

/** Строковые типы — единый источник правды для reducers / sagas */
export const RUN_AI = "RUN_AI";
export const RUN_AI_SUCCESS = "RUN_AI_SUCCESS";
export const RUN_AI_FAILURE = "RUN_AI_FAILURE";
export const RUN_AI_IDLE = "RUN_AI_IDLE";
export const RUN_AI_CLEAR = "RUN_AI_CLEAR";

export const runAI = createAction(RUN_AI) as ActionFunctionAny<Action<void>>;
export const runAISuccess = createAction(RUN_AI_SUCCESS) as ActionFunctionAny<Action<any>>;
export const runAIFailure = createAction(RUN_AI_FAILURE) as ActionFunctionAny<Action<unknown>>;
export const runAIIdle = createAction(RUN_AI_IDLE) as ActionFunctionAny<Action<void>>;
export const runAIClear = createAction(RUN_AI_CLEAR) as ActionFunctionAny<Action<void>>;